import { createReducer } from "typesafe-actions";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";

import { Actions, fetchAllFileTags } from "./actions";

export interface FileTagsState {
  fileTags: FileTag[];
  loading: boolean;
}

const initialState: FileTagsState = {
  fileTags: [],
  loading: false,
};

const fileTags = createReducer<FileTagsState, Actions>(initialState)
  .handleAction(fetchAllFileTags.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchAllFileTags.success, (state, { payload }) => ({
    ...state,
    fileTags: payload,
    loading: false,
  }))
  .handleAction(fetchAllFileTags.failure, (state) => ({
    ...state,
    loading: false,
  }));

export * from "./selectors";

export type FileTagsActions = Actions;

export default fileTags;
